<div id="contenido">
    <div><h1>Woow Ya tienes tu curso Comprado!</h1>
        <h3>Ahora a Programar!!!!</h3>
        <br>
        <h5>Muchas gracias de parte del equipo de Hello Code!</h5>
        <h6>Recorda que tienes soporte para cualquier duda que tengas <a href="mailto:hellocode.equipo@gmail.com?subject=Feedback">Aqui.</a></h6>
        <button (click)="redirigir()">Ir al Curso!</button>
    </div>
</div> 